import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import $http_ari from '../../../axios-instance-ari';
import $http_wor from '../../../axios-instance-wor';

/**
 * Obtener hygienic_measurements.
 */
export async function fetchHygienicMeasurements({state, commit}, reset_page = false) {

    if (reset_page) {
        commit('resetPageParams');
    }

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('hygienic-measurements/' + state.params.company_id, {params: state.params})
        .then(async (response) => {
            commit('setHygienicMeasurements', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener hygienic_measurement.
 */
export async function getHygienicMeasurement({state, commit}, id) {

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('hygienic-measurements/' + state.params.company_id + '/' + id,)
        .then(async (response) => {
            commit('setHygienicMeasurement', response.data.data);

            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            console.error(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear hygienic_measurement.
 */
export async function addHygienicMeasurement({state, commit, dispatch}, company_id = null) {

    let data = state.hygienic_measurement;

    data.company_id = state.params.company_id;

    commit('dashboard/load', true, {root: true});

    if (!!company_id){
        state.params.company_id = company_id
    }

    await $http_ari.post('hygienic-measurements/' + state.params.company_id, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            if (!company_id) {
                await dispatch('fetchHygienicMeasurements');
            }
            commit('setModalShow', false);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            if (this.$vue.$alertErrorsCallback(error)) return;
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Actualizar hygienic_measurement.
 */
export async function updateHygienicMeasurement({state, commit, dispatch}) {

    let data = state.hygienic_measurement;

    data.company_id = state.params.company_id;
    data._method = 'PUT';

    commit('dashboard/load', true, {root: true});

    await $http_ari.post('hygienic-measurements/' + state.params.company_id + '/' + state.hygienic_measurement.id, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await dispatch('fetchHygienicMeasurements');
            commit('setModalShow', false);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            if (this.$vue.$alertErrorsCallback(error)) return;
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Eliminar HygienicMeasurement.
 */
export async function deleteHygienicMeasurement({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar el GES?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, eliminar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            await $http_ari.delete('hygienic-measurements/' + state.params.company_id + '/' + id)
                .then(async (response) => {

                    await dispatch('fetchHygienicMeasurements');
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 2000
                    });


                }).catch((error) => {

                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: error.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}


/**
 * Obtener empresas.
 */
export async function fetchCompanies({commit, state, rootState}, filter) {

    if (!rootState.dashboard.loading && filter && filter.length > 2) {
        commit('dashboard/load', true, {root: true});

        let params = {
            nombre: filter
        };

        await $http.get('/empresas/lista', {params})
            .then((response) => {
                commit('setCompanies', response.data.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener cargos.
 */
export async function fetchPositions({state, commit}) {

    let params = {
        paginate: 0
    };

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('positions/' + state.params.company_id, {params})
        .then(async (response) => {
            commit('setPositions', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener hygienic_measurements.
 */
export async function fetchResults({state, commit}, reset_page = false) {

    if (reset_page) {
        commit('resetPageParamsResults');
    }

    let params = state.params_results

    params.hygienic_measurement_id = state.hygienic_measurement.id

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('hygienic-measurements-results/' + state.params.company_id, {params})
        .then(async (response) => {
            commit('setResults', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener hygienic_measurement.
 */
export async function getResult({state, commit}, id) {

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('hygienic-measurements-results/' + state.params.company_id + '/' + id,)
        .then(async (response) => {
            commit('setResult', response.data.data);

            if (response.data.data.component){
                commit('setComponents', [response.data.data.component])
            }

            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            console.error(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear hygienic_measurement.
 */
export async function addResult({state, commit, dispatch}) {

    let data = state.result;

    data.company_id = state.params.company_id;
    data.ari_hygienic_measurement_id = state.hygienic_measurement.id;

    commit('dashboard/load', true, {root: true});

    await $http_ari.post('hygienic-measurements-results/' + state.params.company_id, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await dispatch('fetchResults');
            commit('setShowToModalResult', false);
            commit('setShowToModalResults', true);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Actualizar hygienic_measurement.
 */
export async function updateResult({state, commit, dispatch}) {

    let data = state.result;

    data.company_id = state.params.company_id;
    data.ari_hygienic_measurement_id = state.hygienic_measurement.id;
    data._method = 'PUT';

    commit('dashboard/load', true, {root: true});

    await $http_ari.post('hygienic-measurements-results/' + state.params.company_id + '/' + state.result.id, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await dispatch('fetchResults');
            commit('setShowToModalResult', false);
            commit('setShowToModalResults', true);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Eliminar Result.
 */
export async function deleteResult({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar la medición higiénica?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, eliminar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            await $http_ari.delete('hygienic-measurements-results/' + state.params.company_id + '/' + id)
                .then(async (response) => {

                    await dispatch('fetchResults');
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 2000
                    });


                }).catch((error) => {

                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: error.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

/**
 * Obtener componentes.
 */
export async function fetchComponents({state, commit}, buscar) {

    commit('dashboard/load', true, {root: true});

    let params = {buscar}

    await $http.post('cas/buscar-componente', params)
        .then(async (response) => {
            commit('setComponents', response.data);

            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            console.error(error);
            commit('dashboard/load', false, {root: true});
        });
}
